export enum ProductStatus {
  Draft,
  Pending,
  Done,
}



// WEBPACK FOOTER //
// ./src/infrastructure/ProductStatus.ts